import React from "react";
import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";


export const PeopleTag = ({peopleNumber={}, iconSize="medium", variant="outlined", color="inherited"}) => {
    return (
        <Stack direction="row" alignItems="center" color={color}>
            {
                variant === "outlined" && <PersonOutlineIcon fontSize={iconSize}/>
            }
            {
                variant === "contained" && <PersonIcon fontSize={iconSize}/>
            }
            <Typography variant="body2" noWrap> x {peopleNumber}</Typography>
        </Stack>
    )
}

PeopleTag.propTypes = {
    peopleNumber: PropTypes.number.isRequired,
    iconSize: PropTypes.string,
    variant: PropTypes.oneOf(["outlined", "contained"])
}

export default PeopleTag;
